import { addRolesToTenantUser, updateTenantUser } from '@infuse/api/iam/tenant';
import { useGenericUpdateUser } from '@infuse/iam/user/mutations';

export const useUpdateTenantUser = () =>
  useGenericUpdateUser({
    apiFn: updateTenantUser,
    roleApiFn: addRolesToTenantUser
  });
